import url from './url';



export default url(({ templateId = ':templateId' }) => `/templates/${templateId}/view`);
